import React from 'react'
import ContactUs from '../components/contactUs'

function Contact() {
  return (
    <ContactUs/>
  )
}

export default Contact